import { inject } from '@angular/core';
import {
  Router,
  CanActivateFn,
  UrlTree,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  UrlSegment,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of, switchMap, filter, first, catchError } from 'rxjs';
import { partnerSelectors } from '@usf/ngrx-order';
import {
  jwtDecode,
  PanAppState,
  UsfTokenStorageService,
} from '@panamax/app-state';

export const vptUserGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  routerState: RouterStateSnapshot,
): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const store = inject(Store);
  const tokenStorageService = inject(UsfTokenStorageService);

  const targetUrl = routerState.url;

  console.log('Checking VPT Guard'); //We will need this for troubleshooting purposes

  const accessToken = tokenStorageService.getAccessToken();
  if (!accessToken) {
    return of(true);
  }

  try {
    const decoded = jwtDecode(accessToken);
    const isPunchthru = decoded['usf-claims']?.punchthruSession;

    if (isPunchthru) {
      return store.select(partnerSelectors.selectPartner).pipe(
        filter(partnerState => !!partnerState?.siteRoleProfile),
        switchMap(partnerState => {
          const orderId = sessionStorage.getItem('vptOrderId');
          if (partnerState?.siteRoleProfile?.exceptionRestricted) {
            if (
              targetUrl.includes(`/order/order-confirmation/${orderId}`) ||
              targetUrl.includes(`/order/order-exceptions`) ||
              (targetUrl.includes('/search/compare') &&
                routerState.root.queryParams['mode'] ===
                  'exceptionSubCompare') ||
              (targetUrl.includes('/search') &&
                routerState.root.queryParams['mode'] === 'exceptionSearch')
            ) {
              return of(true);
            } else {
              return of(
                router.parseUrl(`/order/order-confirmation/${orderId}`),
              );
            }
          } else if (
            partnerState?.siteRoleProfile?.siteRestricted &&
            !targetUrl.includes(`/order/order-confirmation/${orderId}`)
          ) {
            return of(router.parseUrl(`/order/order-confirmation/${orderId}`));
          } else {
            return of(true);
          }
        }),
        catchError(err => {
          return of(true);
        }),
      );
    } else {
      return of(true);
    }
  } catch (err) {
    return of(true);
  }
};
